import { setLocale } from 'yup';

// Yup validation messages
setLocale({
  mixed: {
    // Unset Yup's default message, so that we can fall back to our own translation keys.
    required: undefined,
    default: undefined,
  },
});
